<template>
  <div>
    <my-head></my-head>
    <div class="minH useragreement">
      <div class="crumbs">
        首页 >
        <span style="color: #1d2129">用户协议</span>
      </div>

      <pre class="user_content">
          <h1 class="flex-center">上海知识产权交易中心交易门户服务协议</h1>

          在使用上海知识产权交易中心门户网站(以下简称“门户网站”)服务之前，您应当认真阅读并遵守本协议，请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、争议解决和法律适用条款。

          当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，或您以其他允许的方式实际使用门户网站服务时，即表示您已充分阅读、理解并接受本协议的全部内容。

          一、服务条款范围
          1、除另行明确声明外，门户网站服务包含门户网站提供的任何基于互联网以及移动网的相关服务，且均受本协议约束。如果您不同意本协议的约定，您应立即停止注册或停止使用门户网站服务。
          2、本协议内容包括协议正文及所有门户网站已经发布或将来可能发布的各类规则、公告或通知(以下合称“规则”)。所有规则为本协议不可分割的组成部分，具有同等法律效力。
          3、门户网站有权根据需要来制订、修改本协议及/或各类规则，并以网站公示的方式进行变更公告，无需另行单独通知您。变更后的协议和规则一经在网站公布后，立即或在公告明确的特定时间自动生效。若您在前述变更公告后继续使用门户网站服务的，即表示您已经阅读、理解并接受经修订的协议和规则。若您不同意相关变更，应当立即停止使用门户网站服务。

          二、注册与账户
          您确认，在您完成注册程序或以其他允许的方式实际使用门户网站服务时，您应当是具备完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您应承担由此造成的一切后果，且门户网站有权注销或永久冻结您的账户。
          1、注册和账户
          a)当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，或您以其他允许的方式实际使用门户网站服务时，您即受本协议约束。
          b)您注册成功后，门户网站将为您开通一个账户，作为您在门户网站交易及使用门户网站服务时的唯一身份标识，该账户的登录名和密码请您妥善保管。
          2、用户信息
          a)在注册流程中，您应当依照法律法规要求，按相应页面的提示准确提供您的资料，并于资料信息变更时及时更新，以保证您所提交资料的真实、及时、完整和准确。门户网站搜集的信息包括但不限于您的姓名、性别、年龄、出生日期、身份证号、手机号码等信息，门户网站同意对这些信息的使用将受限于用户个人隐私信息保护的约束。如有合理理由怀疑您提供的资料错误、不实、过时或不完整的，门户网站有权向您发出询问及/或要求改正的通知，并有权直接做出删除相应资料的处理，直至中止、终止对您提供部分或全部门户网站服务。门户网站对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。
          b)您应当准确填写并及时更新您提供的电子邮件地址、联系电话等联系方式，以便门户网站或其他用户与您进行有效联系，因通过这些联系方式无法与您取得联系，导致您在使用门户网站服务过程中产生任何损失或增加费用的，应由您完全独自承担。您了解并同意，您有义务保持你提供的联系方式的真实性、有效性和准确性，如有变更或需要更新的，您应按门户网站的要求进行操作。
          3、账户安全
          （1）您须自行负责对您的门户网站登录名和密码保密，且须对您在该登录名和密码下发生的所有活动(包括但不限于发布信息、网上点击同意、挂牌申请、报名或网上报价、参加活动等)承担责任。您同意：(a)如发现任何人未经授权使用您的门户网站登录名密码，或发生违反保密规定的任何其他情况，您会立即通知门户网站;(b)确保您在每个上网时段结束时，以正确步骤离开网站/服务。门户网站不能也不会对因您未能遵守本款规定而发生的任何损失负责。您理解门户网站对您的请求采取行动需要合理时间，门户网站对在采取行动前已经产生的后果(包括但不限于您的任何损失)不承担任何责任。
          （2）通过个人和企业实名认证的方式在上海知识产权交易中心进行登记备案的，该备案信息作为交易过程的凭证之一。

          三、门户网站服务
          1、通过门户网站服务和其它服务，用户可在门户网站查询项目和服务信息、达成交易意向并进行交易、参加门户网站组织的活动以及使用其它信息服务及技术服务，具体以门户网站提供的服务内容为准。
          2、您了解并同意，门户网站有权应政府部门(包括但不限于司法及行政部门)的要求，向其提供您的用户信息和交易记录等必要信息。如您涉嫌侵犯他人知识产权等合法权益，则门户网站有权在初步判断涉嫌侵权行为存在的情况下，向权利人提供您必要的身份信息。

          四、门户网站服务使用规范
          1、在门户网站服务过程中，您作出如下承诺：
          a)实施的所有行为均遵守国家法律、法规等规范及门户网站各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。
          b)在交易过程中，遵守诚实信用原则，不采取不正当竞争行为，不扰乱网上交易的正常秩序，不从事与网上交易无关的行为。
          c)不发布国家禁止销售的或限制销售的标的或服务信息(除非取得合法且足够的许可)，不发布涉嫌侵犯他人知识产权或其它合法权益的标的或服务信息，不发布违背社会公共利益或公共道德或门户网站认为不适合在门户网站上发布的标的或服务信息，不发布其它涉嫌违法或违反本协议及相关规则的信息。
          d)不对门户网站上的任何数据作商业性利用，包括但不限于在未经门户网站事先书面同意的情况下，以复制、传播等任何方式使用门户网站站上展示的资料。
          e)不使用任何装置、软件或例行程序干预或试图干预门户网站的正常运作或正在门户网站上进行的任何交易、活动。不得采取任何将导致不合理的庞大数据负载加诸门户网站网络设备的行动。
          2、您了解并同意：
          a)如果您违反前述承诺，产生任何法律后果的，您应当自己的名义独立承担所有的法律及相关责任，并确保门户网站免于因此产生任何损失或增加费用。
          b)基于维护门户网站交易秩序及交易安全的需要，门户网站有权在发生扰乱市场正常交易秩序的情形下，采取有关应急处置措施。
          c)经国家行政或司法机关的生效法律文书确认您存在违法或侵权行为，或者门户网站根据自身的判断，认为您的行为涉嫌违反法律法规的规定或涉嫌违反本协议和/或规则的条款的，则门户网站有权公示您的该等涉嫌违法或违约行为及门户网站已对您采取的措施。
          d)对于您在门户网站上发布的涉嫌违法、涉嫌侵犯他人合法权利或违反本协议和/或规则的信息，门户网站有权不经通知您即予以删除，且追究相应责任。
          e)对于您违反本协议项下承诺，或您在门户网站上实施的行为，包括您未在门户网站上实施但已经对门户网站及其用户产生影响的行为，门户网站有权单方认定您行为的性质及是否构成对本协议和/或规则的违反，并根据单方认定结果适用规则予以处理或终止向您提供服务，且无须征得您的同意或提前通知予您。您应自行保存与您行为有关的全部证据，并应对无法提供充要证据而承担的不利后果。
          f)如您涉嫌违反有关法律法规或者本协议之规定，使门户网站遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿门户网站因此造成的任何损失和/或发生的任何费用，包括合理的律师费用。
          
          五、特别授权
          您完全理解并不可撤销地授予门户网站及其关联公司下列权利：
          1、一旦您向门户网站作出任何形式的承诺，且门户网站已确认您违反了该承诺，则门户网站有权立即按您的承诺或协议约定的方式对您的账户采取限制措施，包括中止或终止向您提供服务，并公示您的违约情况。您了解并同意，门户网站无须就相关确认与您核对事实，或另行征得您的同意，且门户网站无须就此限制措施或公示行为向您承担任何的责任。
          2、对于您提供的资料及数据信息，您授予门户网站及其关联公司独家的、永久的、完整的、免费的许可使用权利(并有权在多个层面对该权利进行再授权)。此外，门户网站及其关联公司有权(全部或部份地)使用、复制、修订、改写、发布、翻译、分发、执行和展示您的全部资料数据(包括但不限于注册资料、交易行为数据及全部展示于门户网站的各类信息)或制作其派生作品，并以现在已知或日后开发的任何形式、媒体或技术，将上述信息纳入其它作品内。
          
          六、责任范围和责任限制
          1、门户网站负责按"现状"和"可得到"的状态向您提供门户网站服务。但门户网站对服务不作任何明示或暗示的保证，包括但不限于门户网站服务的适用性、没有错误或疏漏、持续性、准确性、可靠性、适用于某一特定用途。同时，门户网站也不对门户网站服务所涉及的技术及信息的有效性、及时性、准确性、正确性、可靠性和质量、稳定、完整等作出任何承诺和保证。
          2、门户网站仅作为您获取标的或服务信息、物色交易对象、就标的和/或服务的交易进行协商及开展交易的场所，但门户网站无法对交易所涉及的标的的安全或合法性，信息的真实性、完整性、准确性以及交易各方履行其在贸易协议中各项义务的能力进行实质性审查。您应自行谨慎判断确定相关标的及/或信息的真实性、完整性、准确性、合法性和有效性，并自行承担因此产生的任何责任与损失。
          3、门户网站不对因下述任一情况而导致您的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿(无论门户网站是否已被告知该等损害赔偿的可能性)：
          a)使用或未能使用门户网站服务。
          b)通过门户网站服务购买或获取任何标的进行交易等行为或替代行为产生的费用及损失。
          c)对门户网站服务的误解。
          d)任何非因门户网站的原因而引起的与门户网站服务有关的其它损失。
          4、不论在何种情况下，门户网站均不对由于信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，骚乱，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为，以及火灾，洪水，风暴、地震等自然灾害而造成的不能服务或延迟服务承担责任。
          
          七、服务条款终止
          1、出现以下情况时，门户网站有权直接以注销账户的方式终止本协议，并有权永久冻结(注销)您的账户权限和收回账户对应的登录名：
          a)您提供的电子邮箱不存在或无法接收电子邮件，且没有其他方式可以与您进行联系，或门户网站以其它联系方式通知您更改电子邮件信息，而您在门户网站通知后三个工作日内仍未更改为有效的电子邮箱的。
          b)您提供的用户信息中的主要内容不真实或不准确或不及时或不完整。
          c)本协议(含规则)变更时，您明示并通知门户网站不愿接受新的服务协议的。
          d)其它门户网站认为应当终止服务的情况。
          门户网站实施上述行为的，无须为此向您或任何第三方承担任何责任。
          2、您的账户服务被终止或者账户在门户网站的权限被永久冻结(注销)后，门户网站没有义务为您保留或向您披露您账户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。
          3、门户网站终止向您提供部分或全部门户网站服务，门户网站仍享有下列权利：
          a)继续保存您的用户信息及您使用门户网站服务期间的所有交易信息。
          b)您在使用门户网站服务期间存在违法违规行为或违反本协议和/或规则的行为的，门户网站仍可依据本协议向您主张权利。
          4、门户网站中止或终止向您提供门户网站服务后，对于您在服务中止或终止之前的交易行为依下列原则处理，您应独力处理并完全承担进行以下处理所产生的任何争议、损失或增加的任何费用，并应确保门户网站免于因此产生任何损失或承担任何费用：
          5、您在服务中止或终止之前已经上传至门户网站的项目或服务尚未交易的，门户网站有权在中止或终止服务的同时删除此项项目或服务的相关信息。
          
          八、其它
          本协议解释权归上海知识产权交易中心所有。

        </pre>

    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
export default {
  components: { MyHead, MyFooter },

}
</script>

<style lang="scss">
.useragreement {
  width: 80%;
  margin: 0 auto;

  .user_content {
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    *word-wrap: break-word;
    *white-space: normal;
    font-size: 16px;
  }
}
</style>